let classes = null;
export const getClasses = async () => {
    if (classes) return classes;

    const response = await axios.get('/classes?limit=100');
    classes = response.data.data.data;

    return classes;
}